import type { ApolloCache } from '@frameio/graphql-client';
import { AssetParent } from '../gql/generated/AssetParent';

export const getAssetParent = (cache: ApolloCache<any>, id: string) =>
  cache.readFragment({
    fragment: AssetParent,
    fragmentName: 'AssetParent',
    id: cache.identify({
      __typename: 'Asset',
      id,
    }),
    returnPartialData: true,
  });
